import { createRouter, createWebHistory,createWebHashHistory } from 'vue-router'
import Index from '../views/index/Index.vue'

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index,
	  meta: { title: '湖州有房网',keywords:'湖州有房,湖州有房网,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/nhlist',
    name: 'nhlist',
    component: () => import('../views/newhouse/List.vue'),
    meta: { title: '新房_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/esf',
    name: 'esf',
    component: () => import('../views/esf/List.vue'),
    meta: { title: '二手房_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/esfshow/:id',
    name: 'esfshow',
    component: () => import('../views/esf/Show.vue'),
    meta: { title: '二手房详情_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/special',
    name: 'special',
    component: () => import('../views/special/List.vue'),
    meta: { title: '特价房_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/specialshow/:id',
    name: 'specialshow',
    component: () => import('../views/special/Show.vue'),
    meta: { title: '特价房详情_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/community',
    name: 'community',
    component: () => import('../views/esf/Community.vue'),
    meta: { title: '小区_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/communityshow/:id',
    name: 'communityshow',
    component: () => import('../views/esf/CommunityShow.vue'),
    meta: { title: '小区详情_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/adviser',
    name: 'adviser',
    component: () => import('../views/esf/Expert.vue'),
    meta: { title: '小区专家_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/lease',
    name: 'lease',
    component: () => import('../views/lease/Lease.vue'),
    meta: { title: '租房_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/leaseshow/:id',
    name: 'leaseshow',
    component: () => import('../views/lease/Show.vue'),
    meta: { title: '租房详情_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/nhshow/:id',
    name: 'nhshow',
    component: () => import('../views/newhouse/Show.vue'),
    meta: { title: '新房详情_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/business',
    name: 'business',
    component: () => import('../views/business/List.vue'),
    meta: { title: '商业地产_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/businessshow/:id',
    name: 'businessshow',
    component: () => import('../views/business/Show.vue'),
    meta: { title: '商业地产详情_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/housingprice',
    name: 'housingprice',
    component: () => import('../views/housingprice/HousingPrice.vue'),
    meta: { title: '房价_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/tourism',
    name: 'tourism',
    component: () => import('../views/tourism/List.vue'),
    meta: { title: '旅游地产_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/tourismshow/:id',
    name: 'tourismshow',
    component: () => import('../views/tourism/Show.vue'),
    meta: { title: '旅游地产详情_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/decoration',
    name: 'decoration',
    component: () => import('../views/decoration/Decoration.vue'),
    meta: { title: '装修_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/decorationshow/:id',
    name: 'decorationshow',
    component: () => import('../views/decoration/DecorationShow.vue'),
    meta: { title: '装修详情_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/lookspot',
    name: 'lookspot',
    component: () => import('../views/newhouse/Lookspot.vue'),
    meta: { title: '看现场_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/louxlist',
    name: 'louxlist',
    component: () => import('../views/louxun/List.vue'),
    meta: { title: '楼讯_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/louxunshow/:id',
    name: 'louxunshow',
    component: () => import('../views/louxun/Show.vue'),
    meta: { title: '楼讯详情_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/mortgage',
    name: 'mortgage',
    component: () => import('../views/calculation/Mortgage.vue'),
    meta: { title: '贷款计算_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/verification',
    name: 'verification',
    component: () => import('../views/calculation/Verification.vue'),
    meta: { title: '房屋核验_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  {
    path: '/taxes',
    name: 'taxes',
    component: () => import('../views/calculation/Taxes.vue'),
    meta: { title: '税费计算_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
  // 登录服务协议页面
  {
    path: '/serviceAgreement',
    name: 'serviceAgreement',
    component: () => import('../components/public/serviceAgreement.vue'),
    meta: { title: '税费计算_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
  },
      //详情
      {
        path: '/erview/:id',
        name: 'erview',
        component: () => import('../views/newhouse/view'),
        meta: { title: '小区专家_湖州有房网',keywords:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修',description:'湖州有房,湖州楼盘,湖州房产,湖州房地产信息网,湖州房价,湖州特价新房,湖州二手房,湖州房屋出租,湖州商业地产,湖州旅游地产,湖州小区专家,湖州学区房,湖州装修' },
      },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

//动态修改页面title
// router.beforeEach((to, from, next) => {
//   window.document.title = to.meta.title
//   window.document.keywords = to.meta.keywords
//   window.document.description = to.meta.description
//   next()
// })


router.beforeEach((to,from,next)=>{
  /*********动态修改keywords和description*************/
  if(Object.keys(to.meta).length>0 && to.matched.length>0){
    let this_meta=to.matched[to.matched.length-1].meta
    // console.log(this_meta,'---this_meta---')
    if(this_meta.title)document.title=this_meta.title
    let head = document.getElementsByTagName('head');
    let meta_keyword=document.createElement('meta');
    if(document.querySelector('meta[name="keywords"]')){
      document.querySelector('meta[name="keywords"]').setAttribute('content',this_meta.keywords)
    }else{
      meta_keyword.setAttribute('name','keywords')
      meta_keyword.setAttribute('content',this_meta.keywords)
      head[0].appendChild(meta_keyword)
    }
    let meta_description=document.createElement('meta');
    if(document.querySelector('meta[name="description"]')){
      document.querySelector('meta[name="description"]').setAttribute('content',this_meta.description)
    }else{
      meta_description.setAttribute('name','description')
      meta_description.setAttribute('content',this_meta.description)
      head[0].appendChild(meta_description)
    }
  }
  /**********************************************/
  next()
})


export default router
